import { QueryResult } from "../types"

const flattenQueryResult = <T extends Record<string, any>>(
  result: QueryResult<T>
): T[] => result.edges.map(({ node }) => node)

export default flattenQueryResult
